import React from 'react';
import '../styles/NavBar.css';

const HomeIcon = ({ Icon, selected, name, even }) => {
  return (
    <div className={`homeicon ${selected && 'selecticon'} ${even && 'even'}`}>
      <img src={Icon} className="home__icon" alt="home" />
      <p>{name}</p>
    </div>
  );
};

export default HomeIcon;
